module.exports = __webpack_public_path__ + "img/26_187.73b2af18.png";